'use strict'

import ProductBestReviewCard from '@ui/Product/BestReviewCard/component'
import ProductReviewsCard from '@ui/Product/ReviewsCard/component'
import SearchResult from '@ui/Search/Result/component'

export default function (): void {
  document.querySelectorAll<HTMLElement>('.cms__cards .search-result').forEach((element) => {
    SearchResult(element, {}, {})
  })

  document.querySelectorAll<HTMLElement>('.products-reviews__block .product-reviews-card').forEach((element) => {
    ProductReviewsCard(element)
  })

  document.querySelectorAll<HTMLElement>('.best-reviews__block .product-best-review-card').forEach((element) => {
    ProductBestReviewCard(element)
  })
}
